<!--
// app/components/pages/region-tournament/LayoutTournamentKwcNations.vue
-->
<script setup lang="ts">
import { setAliasUrl } from "~~/src/Shared/utils";

const { $getLocale, $t } = useI18n();
</script>

<template>
  <section
    class="overflow-hidden min-h-[calc(100vh-20vh)] md:mx-auto bg-[url('/img/nations/bg-tournament-nations.jpg')] bg-cover bg-top"
  >
    <div class="max-w-7xl mx-auto py-10 px-4 bigsm:py-20 bigsm:px-10">
      <div class="block bigsm:flex bigsm:items-start bigsm:justify-between">
        <div class="bigsm:w-2/5">
          <NuxtImg
            :src="
              setAliasUrl('https://cms-es.kingsleague.pro/wp-content/uploads/2024/12/kwc-nations-470.png')
            "
            alt="Kings World Cup Nations"
            class="hidden bigsm:block w-[370px]"
            width="270"
            height="78"
          />
          <NuxtImg
            :src="
              setAliasUrl('https://cms-es.kingsleague.pro/wp-content/uploads/2024/12/kwc-nations-logo-h.png')
            "
            alt="Kings World Cup Nations"
            class="block bigsm:hidden w-full sm:w-1/2"
            width="519"
            height="140.7"
            sizes="272px sm:327px md:381px"
          />

          <i18n-t keypath="nations.tournament.p1" tag="p" class="text-base bigsm:text-xl mb-5 mt-10">
            <template #kwcNationsStrong>
              <strong>{{ $t("nations.tournament.kwcNationsStrong") }}</strong>
            </template>
            <template #numberNations
              ><strong>{{ $t("nations.tournament.numberNations") }}</strong></template
            >
            <template #formatNew
              ><strong>{{ $t("nations.tournament.formatNew") }}</strong></template
            >
          </i18n-t>
          <i18n-t keypath="nations.tournament.p2" tag="p" class="text-base bigsm:text-xl mb-5">
            <template #firstPhase>
              <strong>{{ $t("nations.tournament.firstPhase") }}</strong>
            </template>
            <template #groupLeaders>
              <strong>{{ $t("nations.tournament.groupLeaders") }}</strong>
            </template>
            <template #seconds>
              <strong>{{ $t("nations.tournament.seconds") }}</strong>
            </template>
            <template #lastChance>
              <strong>{{ $t("nations.tournament.lastChance") }}</strong>
            </template>
          </i18n-t>
          <i18n-t keypath="nations.tournament.p3" tag="p" class="text-base bigsm:text-xl mb-5">
            <template #playoff>
              <strong>{{ $t("nations.tournament.playoff") }}</strong>
            </template>
            <template #finalDate>
              <strong>{{ $t("nations.tournament.finalDate") }}</strong>
            </template>
            <template #stadium>
              <strong>{{ $t("nations.tournament.stadium") }}</strong>
            </template>
          </i18n-t>
        </div>
        <div class="bigsm:w-3/5">
          <div class="px-6 pb-10 bigsm:px-0 bigsm:pb-0 bigsm:pe-6">
            <NuxtImg
              :src="
                setAliasUrl(
                  'https://cms-es.kingsleague.pro/wp-content/uploads/2025/12/kwc-nations-trophy-2026.png'
                )
              "
              alt="Trophy KWC Nations"
              class="w-1/2 max-w-[155px] mt-8 mx-auto"
              width="193"
              height="380"
              sizes="120px md:170px lg:240px"
            />
          </div>

          <div>
            <NuxtImg
              :src="
                setAliasUrl(
                  'https://cms-es.kingsleague.pro/wp-content/uploads/2025/12/phases-nations-2026-noair.png'
                )
              "
              alt="Competition KWC Nations"
              class="max-w-full h-auto mx-auto md:px-4 mt-5 md:mt-10"
              width="1253"
              height="651"
              sizes="420px md:750px lg:1000px"
            />
          </div>
        </div>
      </div>

      <!--      <div class="w-full flex flex-col items-center justify-center my-10 mx-auto">
        <NuxtImg
          :src="
            setAliasUrl(
              'https://cms-es.kingsleague.pro/wp-content/uploads/2024/12/kwc-nations-bracket-draw-1.png'
            )
          "
          alt="Bracket tournament"
          width="1003"
          height="auto"
          sizes="904px lg:1003px"
          class="mb-8"
        />
      </div>-->
    </div>
  </section>
</template>

<style scoped></style>
